import { call, put, takeLatest } from "redux-saga/effects";
import {
  GeneralUtilsAction,
  InitAction,
  PettyCashierContactDetailReportAction
} from "../../../actions";
import * as types from "../../../actions/actionTypes";
import * as contactDetailReportApi from "../../../api/contactReport/detail/pettyCashierContactDetailReport";
import { GetFilterDetail } from "../../../containers/contactReports/filter/tools";

import { SetMessage } from "../../../assets/errorMessages";
import { toastr } from "react-redux-toastr";
import { createBrowserHistory } from "history";
import { PAGE_NUM } from "../../../constants/filters";
import { PAYMENT, RECEIVE } from "../../../constants/accountReviewTypes";
import * as paymentApi from "../../../api/payment/pettyCashierPayment";
import * as receiveApi from "../../../api/receive/pettyCashierReceive";

export function* pettyCashierWatcherContactDetailReport() {
  yield takeLatest(
    types.PETTY_CASHIER_GET_CONTACT_DETAIL_REVIEW_REQUEST,
    worker
  );
  yield takeLatest(
    types.PETTY_CASHIER_REMOVE_CONTACT_DETAIL_REVIEW_REQUEST,
    remove
  );
}

async function fetchList(pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";

  return contactDetailReportApi.getList(page_number, GetFilterDetail());
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(PettyCashierContactDetailReportAction.getSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierContactDetailReportAction.getFailure(message));
  }
}

async function removeRequest(id, account_type) {
  if (account_type === PAYMENT) {
    return paymentApi.remove(id);
  } else if (account_type === RECEIVE) {
    return receiveApi.remove(id);
  }
}

function* remove(action) {
  try {
    const response = yield call(removeRequest, action.id, action.account_type);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const responseReq = yield call(fetchList, action.pageNumber);
    const history = createBrowserHistory();
    const urlParams = new URLSearchParams(window.location.search);
    const pNum = urlParams.get(PAGE_NUM);
    if (pNum !== action.pageNumber) {
      urlParams.set(PAGE_NUM, action.pageNumber);
      history.push({ search: urlParams.toString() });
    }
    yield put(
      PettyCashierContactDetailReportAction.removeSuccess(responseReq.data)
    );
    yield put(GeneralUtilsAction.closeConfirmForTable());
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
  } catch (error) {
    SetMessage(error, true);
    yield put(PettyCashierContactDetailReportAction.removeFailure());
  }
}
